import { useMutation, useQuery } from 'react-query';
import { RecruitmentSkillServices } from '@api/RecruitmentSkillService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListRecruitmentSkill = (
  [page_no, searchText, selectedStatus],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-candidate-skills-list', page_no, searchText, selectedStatus],
    RecruitmentSkillServices.listRecruitmentSkill,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddRecruitmentSkill = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSkillServices.addRecruitmentSkill, {
    onSuccess,
    onError
  });
};
// Details
const useViewRecruitmentSkill = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-skills-view', () => RecruitmentSkillServices.viewRecruitmentSkill(id), {
    onSuccess,
    onError
  });
};
// Details
const useShowRecruitmentSkill = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-skills-show', () => RecruitmentSkillServices.showRecruitmentSkill(id), {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentSkill = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSkillServices.updateRecruitmentSkill, {
    onSuccess,
    onError
  });
};
// Delete
const useDeleteRecruitmentSkill = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSkillServices.deleteRecruitmentSkill, {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentSkillStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSkillServices.changeStatusRecruitmentSkill, {
    onSuccess,
    onError
  });
};
export {
    useListRecruitmentSkill,
    useAddRecruitmentSkill,
    useViewRecruitmentSkill,
    useShowRecruitmentSkill,
    useDeleteRecruitmentSkill,
    useUpdateRecruitmentSkillStatus,
    useUpdateRecruitmentSkill
};
